export const phoneRegexp = /\+\d\s\(\d{3}\)\s\d{3}-\d{2}-\d{2}/
export const nameSurnameRuRegexp = /[ЁА-яё-]{2,}\s[ЁА-яё-]{2,}/

export const ruNameRegexp = /[\sа-яё-]/i
export const notRuNameRegexp = /[^\sа-яё-]/i

export const uzNameRegexp = /[\sa-zʻʼ]/i
export const notUzNameRegexp = /[^\sa-zʻʼ]/i

export const enNameRegexp = /[\sa-z]/i
export const notEnNameRegexp = /[^\sa-z]/i

export const symbolNameRegexp = /^[\s-]*$/ // Дополнительная проверка, чтобы не пролезали фио, состоящие только из дефисов

export const numLatinLettersRegexp = /^[\da-z]*$/i
export const notNumLatinLettersRegexp = /[^\da-z]/i

export const notCardHolderRegexp = /[^\s'.a-z-]/i
export const isCardHolderRegexp = /[\s'.a-z-]/i

export const charIsRusLetterWithSpaces = (char?: string) => {
  return ruNameRegexp.test(char || '')
}

export const charIsUzLetterWithSpaces = (char?: string) => {
  return uzNameRegexp.test(char || '')
}

export const replaceNotRusSymbols = (val: string) => {
  return val.replace(notRuNameRegexp, '')
}

export const replaceNotUzSymbols = (val: string) => {
  return val.replace(notUzNameRegexp, '')
}

export const charIsEnSymbol = (char?: string) => {
  return enNameRegexp.test(char || '')
}

export const replaceNotEnSymbol = (val: string) => {
  return val.replace(notEnNameRegexp, '')
}

export const charIsNumOrLatinLetterSymbol = (char?: string) => {
  return numLatinLettersRegexp.test(char || '')
}

export const replaceNotNumOrLatinLetterSymbol = (val: string) => {
  return val.replace(notNumLatinLettersRegexp, '')
}

export const charIsCardHolderSymbol = (char?: string) => {
  return isCardHolderRegexp.test(char || '')
}

export const replaceNotCardHolderSymbol = (val: string) => {
  return val.replace(notCardHolderRegexp, '')
}

export const removeDoubleSpaces = (val: string): string => {
  return val.replace(/\s{2,}/g, ' ')
}

export const localeNumber = (rawAmount: string | undefined) => {
  let number = ''
  if (rawAmount == undefined) return ''
  const formattedAmount = rawAmount.replace(',', '.').replace(' ', '')

  number =
    Number(formattedAmount) > 10_000
      ? Number(formattedAmount).toLocaleString('ru-RU', {
          maximumFractionDigits: 2,
        })
      : Number(formattedAmount).toFixed(2)
  return number.replace('.00', '').replace('.', ',')
}

export const removeLeadingZeroes = (value: string) => {
  return value.replace(/^0+(?=\d)/, '')
}
